export enum RoleType {
    Admin = "School Admin",
    StoryAdmin = "Story Admin",
    StorySelector = "Story Selector",
    StoryAnnotator = "Story Annotator",
    StoryPublisher = "Story Publisher",
    ProgrammeCoordinator = "Teaching Staff",
    Facilitator = "Support Staff",
}
